import React from "react";
import { Alert, Card } from "react-bootstrap";

function GettingStarted() {
  return (
    <div>
      <h2 className="mb-4">Getting Started</h2>

      <Alert variant="info">
        <strong>Welcome!</strong> This guide will help you understand the basics of using the Customer Portal.
      </Alert>

      <Card className="mb-4">
        <Card.Body>
          <h4>What is the Customer Portal?</h4>
          <p>
            The Customer Portal is an automation platform that allows you to create, execute, and schedule runbooks.
            Runbooks are automated workflows that can perform tasks, integrate with external systems, and process data.
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Logging In</h4>
          <ol>
            <li>Navigate to the portal login page</li>
            <li>Enter your email address and password</li>
            <li>If your organization uses SSO (Single Sign-On), you may be redirected to your organization's login page</li>
            <li>After successful authentication, you'll be redirected to the Dashboard</li>
          </ol>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Navigating the Portal</h4>
          <p>The portal has a left sidebar menu with the following sections:</p>
          <ul>
            <li><strong>Dashboard</strong> - Your home page with widgets showing favorites, recent executions, and upcoming schedules</li>
            <li><strong>My Runbooks</strong> - View and manage all your runbooks</li>
            <li><strong>My Schedulers</strong> - Create and manage automated schedules</li>
            <li><strong>My Variables</strong> - Store reusable data that runbooks can reference</li>
            <li><strong>My Connectors</strong> - Manage authentication credentials for external systems</li>
          </ul>
          <p className="mt-3">
            <strong>Admin users</strong> will also see additional menu items for managing users, invitations, and permissions.
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Your Profile</h4>
          <p>
            Click on your name in the top-right corner to access your profile and see your user information, assigned client, and role.
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Next Steps</h4>
          <ul>
            <li>Explore the <strong>Dashboard</strong> to see your recent activity</li>
            <li>Check out the <strong>Runbooks Overview</strong> to learn about creating workflows</li>
            <li>Read about <strong>Schedulers</strong> to automate your runbooks</li>
          </ul>
        </Card.Body>
      </Card>
    </div>
  );
}

export default GettingStarted;
